import styled from 'styled-components';

/**
 * Акцент обов'язкових полів: крупна червона зірочка в лейблі + кольорова смуга зліва всередині контролу.
 * Смуга — inset box-shadow: не зсуває верстку і не обрізається контейнером.
 * Порожнє поле — червона смуга, заповнене — зелена.
 */
const Star = styled.span`
  color: var(--spark-color-error-text);
  font-size: 1.3em;
  font-weight: 700;
  line-height: 1;
  margin-left: 4px;
  vertical-align: -0.1em;
`;

export const RequiredStar = () => <Star aria-hidden="true">*</Star>;

const barShadow = (p) => (p.$accent
  ? `inset 3px 0 0 ${p.$filled ? 'var(--spark-color-success-text)' : 'var(--spark-color-error-text)'}`
  : null);

/** Склеює зовнішні тіні (фокус-кільце тощо) зі смугою обов'язковості. */
export const withRequiredBar = (p, ...shadows) => [...shadows, barShadow(p)].filter(Boolean).join(', ') || 'none';

export const isFilled = (value) => String(value ?? '').trim() !== '';
